import script from "./GestaoPesquisaProcessos_72.vue?vue&type=script&setup=true&lang=js"
export * from "./GestaoPesquisaProcessos_72.vue?vue&type=script&setup=true&lang=js"

import "./GestaoPesquisaProcessos_72.vue?vue&type=style&index=0&id=779889b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-779889b2"]])

export default __exports__